<template>
    <rkm-form
        ref="RkmForm"
        show-legend
    >
        <rkm-overlay :show="loading">
            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-input
                        :validations="validations.phone_number_id"
                        label="ID do número WABA"
                        placeholder="Ex.: 123456789012345"
                        v-model="model.phone_number_id"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :validations="validations.display_phone_number"
                        label="Número do WhatsApp"
                        placeholder="Ex.: +5511999999999"
                        v-model="model.display_phone_number"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :validations="validations.verified_name"
                        label="Nome verificado"
                        v-model="model.verified_name"
                    />
                </rkm-col>
            </rkm-row>

        </rkm-overlay>
    </rkm-form>
</template>

<script>
// Mixins.
import {error} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('cadastro-waba-form')
        },
        validations() {
            return {
                phone_number_id: {
                    numeric: true,
                },
                display_phone_number: {
                    required: true,
                    min: 10,
                    max: 30,
                },
                verified_name: {
                    required: true,
                    min: 3,
                    max: 255,
                },
            }
        },
    },
    data: () => ({
        model: {
            phone_number_id: null,
            display_phone_number: null,
            verified_name: null,
        },
    }),
    inject: ['repositories'],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            if (!this.id) {
                return
            }

            this.setLoading('cadastro-waba-form')

            this.repositories.cadastro.waba.edit(this.id)
                .then(({data}) => this.model = data.model)
                .catch(this.handleError)
                .finally(() => this.unsetLoading('cadastro-waba-form'))
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(validated => {
                    if (validated) {
                        this.setLoading('cadastro-waba-form')

                        const request = {...this.model}

                        if (this.id) {
                            this.repositories.cadastro.waba.update(request, this.id)
                                .then(({data}) => this.$emit('save', data))
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading('cadastro-waba-form'))
                        } else {
                            this.repositories.cadastro.waba.store(request)
                                .then(({data}) => this.$emit('save', data))
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading('cadastro-waba-form'))
                        }
                    }
                })
        },
    },
    mixins: [error],
    mounted() {
        this.load()
    },
    props: {
        id: {type: Number},
    },
}
</script>
